
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { iForeignKey } from '../../Metaweb'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import metawebForeignKeyTabDescriptor from './MetawebForeignKeyTabDescriptor.json'

export default defineComponent({
    name: 'metaweb-foreign-key-tab',
    components: { Column, DataTable },
    props: { propForeignKeys: { type: Array } },
    data() {
        return {
            metawebForeignKeyTabDescriptor,
            foreignKeys: [] as iForeignKey[],
            filters: { global: [filterDefault] } as Object
        }
    },
    watch: {
        propForeignKeys() {
            this.loadForeignKeys()
        }
    },
    created() {
        this.loadForeignKeys()
    },
    methods: {
        loadForeignKeys() {
            this.foreignKeys = this.propForeignKeys as iForeignKey[]
        },
        getColumns(foreignKey: iForeignKey, columnType: string) {
            const columns = [] as string[]
            for (let i = 0; i < foreignKey[columnType].length; i++) {
                columns.push(foreignKey[columnType][i].tableName + '.' + foreignKey[columnType][i].name)
            }

            return columns.join(',')
        }
    }
})
